/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DownloadTaskResponse } from '../models/download-task-response';

@Injectable({
  providedIn: 'root',
})
export class DownloadApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDownloadUrl
   */
  static readonly GetDownloadUrlPath = '/downloadUrl';

  /**
   * Get download url by exportJobId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDownloadUrl$Response(params: {

    /**
     * The task id of the export task.
     */
    exportTaskId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<DownloadTaskResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DownloadApiService.GetDownloadUrlPath, 'get');
    if (params) {
      rb.query('exportTaskId', params.exportTaskId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DownloadTaskResponse>;
      })
    );
  }

  /**
   * Get download url by exportJobId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDownloadUrl(params: {

    /**
     * The task id of the export task.
     */
    exportTaskId: string;
  },
  context?: HttpContext

): Observable<DownloadTaskResponse> {

    return this.getDownloadUrl$Response(params,context).pipe(
      map((r: StrictHttpResponse<DownloadTaskResponse>) => r.body as DownloadTaskResponse)
    );
  }

}
